import { a as lazyReveal } from "./utilities-2Suih3Nm.js";
class PageTag extends HTMLElement {
  constructor() {
    super();
    this.articleListingSelector = ".pagination-container";
    this.paginationSelector = "page-pagination-component";
    this.isLoading = false;
  }
  connectedCallback() {
    this.cacheNodes();
    this.bindEvents();
  }
  disconnectedCallback() {
    this.unbindEvents();
  }
  // ========== DOM & Configuration ==========
  cacheNodes() {
    this.categoryButtons = this.querySelectorAll(".tag-btn-label");
    this.articleListing = document.querySelector(this.articleListingSelector);
  }
  // ========== Event Binding ==========
  bindEvents() {
    this.handleCategoryClick = this.handleCategoryClick.bind(this);
    this.categoryButtons.forEach((btn) => {
      btn.addEventListener("click", this.handleCategoryClick);
    });
  }
  unbindEvents() {
    this.categoryButtons.forEach((btn) => {
      btn.removeEventListener("click", this.handleCategoryClick);
    });
  }
  // ========== AJAX Fetching ==========
  async handleCategoryClick(event) {
    event.preventDefault();
    if (this.isLoading) return;
    const link = event.currentTarget;
    const url = link.href;
    this.updateActiveState(link);
    window.history.pushState({}, "", url);
    await this.fetchArticles(url);
  }
  async fetchArticles(url) {
    this.isLoading = true;
    this.showLoadingState();
    try {
      const response = await fetch(url, {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const html = await response.text();
      this.updateContent(html, url);
    } catch (error) {
      window.location.href = url;
    } finally {
      this.isLoading = false;
      this.hideLoadingState();
    }
  }
  // ========== Content Update ==========
  updateContent(html, currentUrl) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const newArticleListing = doc.querySelector(this.articleListingSelector);
    if (newArticleListing && this.articleListing) {
      const style = getComputedStyle(this.articleListing);
      const durationVar = style.getPropertyValue("--transition-duration") || "200ms";
      const duration = durationVar.includes("ms") ? parseInt(durationVar) : parseFloat(durationVar) * 1e3;
      this.articleListing.style.opacity = "0";
      setTimeout(() => {
        this.articleListing.innerHTML = newArticleListing.innerHTML;
        this.articleListing.style.opacity = "1";
        const currentPagination = document.querySelector(this.paginationSelector);
        const newPagination = doc.querySelector(this.paginationSelector);
        if (currentPagination && newPagination) {
          this.patchPaginationUrls(newPagination, currentUrl);
          currentPagination.outerHTML = newPagination.outerHTML;
        } else if (currentPagination && !newPagination) {
          currentPagination.innerHTML = "";
        } else if (!currentPagination && newPagination) {
          const articleSection = document.querySelector(".article-page-listing");
          if (articleSection) {
            articleSection.insertAdjacentHTML("afterend", newPagination.outerHTML);
          }
        }
        const countSelector = ".sc-page-heading-title-count";
        const newCount = doc.querySelector(countSelector);
        const currentCount = document.querySelector(countSelector);
        if (newCount && currentCount) {
          currentCount.innerText = newCount.innerText;
        }
        lazyReveal(this.articleListing);
      }, duration);
    }
  }
  // ========== URL Patching ==========
  patchPaginationUrls(newPagination, currentUrl) {
    const urlObj = new URL(currentUrl);
    const taggedPathMatch = urlObj.pathname.match(/\/tagged\/([^/?#]+)/);
    const taggedPath = taggedPathMatch ? taggedPathMatch[0] : "";
    const dataUrlInput = newPagination.querySelector("[data-url]");
    const baseBlogUrl = dataUrlInput ? dataUrlInput.value : "";
    if (baseBlogUrl) {
      if (dataUrlInput && taggedPath && !dataUrlInput.value.includes(taggedPath)) {
        dataUrlInput.value = baseBlogUrl + taggedPath;
      }
      const nextLinkInput = newPagination.querySelector("[data-next-link]");
      if (nextLinkInput && nextLinkInput.value) {
        const nextUrl = new URL(nextLinkInput.value, window.location.origin);
        if (taggedPath && !nextUrl.pathname.includes(taggedPath)) {
          if (nextUrl.pathname.startsWith(baseBlogUrl)) {
            nextUrl.pathname = nextUrl.pathname.replace(baseBlogUrl, baseBlogUrl + taggedPath);
          } else {
            nextUrl.pathname = nextUrl.pathname.split("?")[0] + taggedPath;
          }
          nextLinkInput.value = nextUrl.pathname + nextUrl.search;
        }
      }
      newPagination.querySelectorAll(".page-pagination-item a").forEach((link) => {
        const linkUrl = new URL(link.href, window.location.origin);
        if (taggedPath && !linkUrl.pathname.includes(taggedPath)) {
          if (linkUrl.pathname.startsWith(baseBlogUrl)) {
            linkUrl.pathname = linkUrl.pathname.replace(baseBlogUrl, baseBlogUrl + taggedPath);
            link.href = linkUrl.pathname + linkUrl.search;
          }
        }
      });
    }
  }
  // ========== UI State Updates ==========
  updateActiveState(activeLink) {
    this.querySelectorAll(".tag-btn-content-inner").forEach((btn) => {
      btn.classList.remove("active");
    });
    const parentContent = activeLink.closest(".tag-btn-content-inner");
    if (parentContent) {
      parentContent.classList.add("active");
    }
  }
  showLoadingState() {
    const area = document.querySelector(".pagination-content-inner");
    if (area) {
      area.style.opacity = "0.5";
      area.style.pointerEvents = "none";
      area.style.transition = "opacity var(--trans-duration) var(--trans-easing)";
    }
  }
  hideLoadingState() {
    const area = document.querySelector(".pagination-content-inner");
    if (area) {
      area.style.opacity = "1";
      area.style.pointerEvents = "";
    }
  }
}
if (!customElements.get("page-tag")) {
  customElements.define("page-tag", PageTag);
}
